import React, { useContext, useEffect, useState } from 'react';
import { NavContext } from '@components/navigation/Context';
import { AnimationContainer, FullPageContainer } from '@components/navigation/NavAnimation';
import NavBasketBox from '@components/navigation/NavBasketBox';
import useDesktop from '@components/shared/useDesktop';
import { NavStatus } from '@contracts';

const NavBasketMenu: React.FC = () => {
  const { navState, navDispatch } = useContext(NavContext);
  const [showContainer, setShowContainer] = useState(false);
  const [animateIn, setAnimateIn] = useState(false);
  const { status } = navState;
  const desktop = useDesktop();

  function handleCloseNav() {
    navDispatch({ type: 'setStatus', data: NavStatus.Default });
  }

  useEffect(() => {
    if (status === NavStatus.Basket) {
      setShowContainer(true);
      setTimeout(() => {
        setShowContainer(true);
        setAnimateIn(true);
      }, 200);
    } else {
      setAnimateIn(false);
      setTimeout(() => {
        setShowContainer(false);
      }, 200);
    }
  }, [status]);

  return (
    <FullPageContainer $open={showContainer} $right={true} onClick={handleCloseNav} $animateIn={animateIn} $onTop={desktop}>
      <AnimationContainer $width={!desktop ? '100%' : ''} $open={animateIn}>
        <NavBasketBox />
      </AnimationContainer>
    </FullPageContainer>
  );
};

export default NavBasketMenu;
